import React, { useState } from 'react';
import axios from 'axios';
import { ADMIN_API } from '../../utils/adminApi';


const AdminLogin = ({ onSuccess }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (submitting) return;
    setError('');
    setSubmitting(true);
    try {
      const res = await axios.post(
        `${ADMIN_API}/api/admin/login`,
        { email, password },
        { withCredentials: true },
      );
      // { ok, rol, nombre }: la página decide con el rol a dónde va (un setter, a /admin/setting).
      onSuccess(res?.data || {});
    } catch (err) {
      const msg = err?.response?.data?.error || 'Error al autenticar';
      setError(msg);
      setSubmitting(false);
    }
  };

  return (
    <div className="au-admin au-admin-login-screen">
      <div className="au-admin-login-card">
        <div className="brand">AU &gt;&gt;</div>
        <div className="label">ADMIN ACCESS</div>
        <div className="prompt">&gt;&gt; CORREO</div>
        <form onSubmit={handleSubmit}>
          <input
            type="email"
            autoFocus
            autoComplete="username"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            disabled={submitting}
          />
          <div className="prompt">&gt;&gt; CONTRASEÑA</div>
          <input
            type="password"
            autoComplete="current-password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            disabled={submitting}
          />
          <button type="submit" disabled={submitting || !email || !password}>
            {submitting ? 'AUTENTICANDO…' : 'AUTENTICAR'}
          </button>
          {error && <div className="error">&lt; {error}</div>}
        </form>
      </div>
    </div>
  );
};

export default AdminLogin;
